import BaseApi from './BaseApi'

export default {
  async createSiteMeasure(data) {
    return await BaseApi.post('/site-safety-health-measures/new', data)
  },
  
  async searchSiteMeasures(params) {
    return await BaseApi.get('/site-safety-health-measures/search', { params })
  },
  
  async updateSiteMeasure(id, data) {
    return await BaseApi.post(`/site-safety-health-measures/${id}/update`, data)
  },
  
  async deleteSiteMeasure(id) {
    return await BaseApi.post(`/site-safety-health-measures/${id}/delete`)
  },
  
  async getSiteMeasure(id) {
    return await BaseApi.get(`/site-safety-health-measures/${id}`)
  },
  
  async createResponsible(measureId, data) {
    return await BaseApi.post(`/site-safety-health-measures/${measureId}/responsibles/new`, data)
  },
  
  async searchResponsibles(measureId) {
    return await BaseApi.get(`/site-safety-health-measures/${measureId}/responsibles/search`)
  },
  
  async updateResponsible(measureId, responsibleId, data) {
    return await BaseApi.post(`/site-safety-health-measures/${measureId}/responsibles/${responsibleId}/update`, data)
  },
  
  async deleteResponsible(measureId, responsibleId) {
    return await BaseApi.post(`/site-safety-health-measures/${measureId}/responsibles/${responsibleId}/delete`)
  },
  
  async getResponsible(measureId, responsibleId) {
    return await BaseApi.get(`/site-safety-health-measures/${measureId}/responsibles/${responsibleId}`)
  },
  
  async reorderSiteMeasures(data) {
    return await BaseApi.post('/site-safety-health-measures/reorder', data)
  },

  async generateSafetyPosterExcel(siteId, targetMonth) {
    return await BaseApi.post('/site/generate-safety-poster-excel', {
      siteId,
      targetMonth
    })
  }
}
